var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg8D(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2412_2682)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9316 0.547089H39.9314H24.3529H22.9878H12.83H11.4656H-0.0573534V16.1261H-0.0581055V27.6488V29.0133V40.5361L-0.0573534 40.5361H39.9316V0.547089ZM1.30718 29.0133V39.1715L15.521 39.1715V29.0133L1.30718 29.0133ZM1.30718 27.6488V17.4906H11.4656H12.83L15.521 17.4906V27.6488H1.30718ZM16.8855 16.1261L22.9878 16.1261V13.4343V12.0698V1.91162H12.8301V16.1261H16.8855ZM11.4655 16.1261V1.91162H1.30718V16.1261L11.4655 16.1261ZM28.4086 23.5925L38.5669 23.5926V13.4344L24.3529 13.4343V17.4906H24.3523V23.5925H27.0442H28.4086ZM16.8858 24.9571H22.9878V24.9571H27.0441V39.1715H16.8858V24.9571ZM28.4087 39.1715V24.9571L38.567 24.9571V39.1715H28.4087ZM38.5669 1.91162H24.3529V12.0698L38.5669 12.0698V1.91162Z",
    fill: "#041E42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2412_2682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.47934)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8D);
export default __webpack_public_path__ + "static/media/8d.663ee70f6fe4530055006be11c282deb.svg";
export { ForwardRef as ReactComponent };